import React from 'react';

interface AppOpeningSplashProps {
  message?: string;
}

export const AppOpeningSplash: React.FC<AppOpeningSplashProps> = ({ message }) => {
  return (
    <div
      className="fixed inset-0 z-[99999] flex flex-col items-center justify-center bg-white select-none overflow-hidden"
      style={{
        background: 'linear-gradient(to top, rgba(5, 150, 105, 0.08) 0%, rgba(16, 185, 129, 0.03) 30%, #ffffff 65%)',
      }}
    >
      {/* Halo lumineux d'ambiance ultra-léger au bas de l'écran */}
      <div
        className="absolute -bottom-10 left-1/2 -translate-x-1/2 w-[520px] max-w-[90vw] h-44 rounded-full pointer-events-none blur-3xl opacity-70"
        style={{ background: 'radial-gradient(circle, rgba(16, 185, 129, 0.12) 0%, rgba(255, 255, 255, 0) 70%)' }}
      />

      {/* Contenu centralisé : Logo complet Zeyilo */}
      <div className="relative z-10 flex flex-col items-center text-center px-6 -translate-y-2">
        <img
          src="/logo.webp"
          srcSet="/logo.webp 1x, /logo-full.webp 2x"
          alt="Zeyilo"
          width={320}
          height={188}
          decoding="async"
          className="h-11 sm:h-12 w-auto object-contain drop-shadow-[0_2px_8px_rgba(0,0,0,0.03)]"
        />

        {/* Barre de chargement fine et élégante */}
        <div className="mt-7 w-12 h-[2.5px] bg-emerald-900/10 rounded-full overflow-hidden relative">
          <div
            className="h-full bg-emerald-600 rounded-full"
            style={{
              animation: 'zeyiloSplashBar 1.2s cubic-bezier(0.4, 0, 0.2, 1) infinite',
            }}
          />
        </div>

        {message && (
          <p className="mt-3 text-xs font-medium text-slate-400 tracking-wide animate-pulse">
            {message}
          </p>
        )}
      </div>

      <style>{`
        @keyframes zeyiloSplashBar {
          0% {
            width: 20%;
            transform: translateX(-100%);
          }
          50% {
            width: 60%;
            transform: translateX(50%);
          }
          100% {
            width: 20%;
            transform: translateX(500%);
          }
        }
      `}</style>
    </div>
  );
};
